import axios from "axios";
import {Storage} from "@/Services/Storage";
import Swal from "sweetalert2";
import Vue from "vue";
// import Vue from "vue";
// import {resolve} from "img-vuer/webpack.config";


export default {
    name: 'user',
    state: {
        allUsers: [],
        current_user: null,
        userTypes: ['Super_User', 'Developer', 'Technician', 'Sales'],
        currentSession : undefined,
        attemptedLoginRoute : { name : `SelectRequest` },
        deviceId: null,
    },
    getters: {
        getAllUsers: (state) => state.allUsers,
        getCurrentUser: (state) => state.current_user,
        getSessionID: (state) => state.currentSession,
        getUserTypes: (state) => state.userTypes,
        getDeviceId: (state) => state.deviceId,
    },
    mutations: {
        setDeviceId(state, deviceId) {
            state.deviceId = deviceId;
        },
        setCurrentUser: async (state, data) => {
            // GINGER-20260710-FILE4-LIVE: persist user object to Capacitor Storage so
            // browser refresh hydrates current_user immediately, no /verifyOtp round-trip
            // needed. Defense in depth alongside v1.4.3 BE envelope refactor.
            state.current_user = data
            // GINGER-20260710-USERID-TELEMETRY-FIX: mirror user.id onto window.userId SYNCHRONOUSLY
            // (before the Storage await) so the very next router.afterEach (page:SelectRequest /
            // page:Funds / etc.) sees a real user id instead of null. The legacy
            // window.usageTracker.track() path falls back to window.userId and there is no caller-side
            // userId passed. Covers login flow AND restoreSession refresh hydration. Matches the
            // user_id that's already present on auth/login events. Wrapped in guarded try/catch so
            // a Storage failure (e.g. @capacitor/storage throwing in PWA web build) cannot block the
            // mirror — telemetry must never break because persistence failed.
            if (data && data.id != null) window.userId = data.id
            if (data) {
                try { await Storage.setCurrentUser(data) }
                catch (err) { console.warn('[setCurrentUser] storage write failed (non-fatal):', err && err.message) }
            }
        },
        clearCurrentUser: async (state) => {
            // GINGER-20260710-FILE4-LIVE: fixed pre-existing typo (state.currentUser → state.current_user)
            // and added Storage.clearCurrentUser() so logout / verify-session-failure actually purges persistence
            state.current_user = null;
            await Storage.clearCurrentUser();
            // GINGER-20260710-USERID-TELEMETRY-FIX: clear window.userId so the next page view after
            // logout doesn't keep stamping the old user id on telemetry. Pairs with setCurrentUser mirror.
            window.userId = null;
        },
        setUsers: async (state, data) => {
            if (data) await Storage.setUsers(data)
            else data = await Storage.getAllUsers();
            state.allUsers = data;
        },
        // setCurrentUser : async (state , payload) => {
        //     if (payload) await Storage.setCurrentUser(payload);
        //     else await Storage.getCurrentUser();
        //     state.currentUser = payload;
        // },
        setSessionID : async (state , payload) => {
            if (payload) await Storage.setSessionID(payload);
            else await Storage.getSessionID();
            state.currentSession = payload;
        },
        setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
    },
    actions: {

        getAllUsers: async (context) => {
            return axios.get(ticketApi + `user/getAll`)
                .then(({data}) => {
                    context.commit('setUsers', data)
                    console.log(data)
                });
        },
        validateUser: (context, payload) => {
            return axios.post(ticketApi2 + 'login', payload)
                .then(({data}) => {
                    // GINGER-20260710-USERID-CONSOLIDATION-FIX: BE /login envelope
                    // now exposes `id` (matching the standard user shape). The stub
                    // synthesis added by USERID-MERCHANT-FIX is no longer needed —
                    // commit `data` directly so curUser.id, curUser.wallets, and
                    // any other fields populate normally for both shapes.
                    //
                    // Historical (USERID-MERCHANT-FIX, v1.4.1, dropped here):
                    //   merchant envelope shipped `userId` (camelCase) instead of
                    //   `id`, so curUser.id was undefined and NavigationDrawer.vue:
                    //   checkIsManger() fired ?userid=undefined → Spring 400.
                    //   Fix was a synthetic stub {id:1, Type:'Merchant', wallets:[]}
                    //   replaced by the real user after /verifyOtp.
                    //
                    // The form still gates on `result.sessionRequestId` to decide
                    // whether to persist pendingMerchant* keys to localStorage.
                    // NEVER gate on users.Type per Jabulani's literal-id rule.
                    // Defense-in-depth: checkIsManger (NavigationDrawer.vue:204)
                    // still returns early when curUser.id is null — covers any
                    // future BE regression that drops the id field again.
                    context.commit('setCurrentUser', data)
                    responses.showSuccess(`Success , Please verify OTP`)
                    return data;
                }).catch(err => errorHandler.tomcatError(err))
        },
        validateUser2: (context, payload) => {
            return axios.post(ticketApi2 + 'verifyOtp', payload)
                .then(async ({data}) => {
                    // GINGER-20260710-FILE3-LIVE: BE /verifyOtp now returns
                    // {sessionId, user} envelope (was bare String). Extract the
                    // sessionId string for the legacy localStorage round-trip
                    // and the user object for current_user. See
                    // Help Desk/docs/handoffs/handoff-sam-file3-live-v1-4-3-20260710.md.
                    context.commit('setSessionID', data.sessionId)
                    // GINGER-20260709-USERID-TYPE-FIX: refresh Vuex current_user from verifyOtp response.
                    // Without this, curUser.id is null on page-restore/refresh paths and
                    // NavigationDrawer.vue:checkIsManger() fires isuserManager?userid=undefined
                    // → Spring throws "the parameter 'userid' should be of type int".
                    // GINGER-20260710-FILE3-LIVE: dormant line now LIVES — both standard
                    // and merchant (id=1) /verifyOtp paths return data.user.
                    if (data.user) await context.commit('setCurrentUser', data.user)
                    responses.showSuccess(`User Log in success`)

                    // GINGER-20260711-USERID-MERCHANT-DASHBOARD-FIX:
                    // After commit, check if current_user.wallets is empty (Shape C/D /verifyOtp path sometimes
                    // returns wallets, sometimes doesn't — depends on the MCQL hydration path). For merchant (id=1),
                    // Shape D almost always returns wallets=[], so we ALWAYS dispatch the wallet fetch to be safe.
                    // The action is idempotent: if wallets are already populated, the fetch overwrites with the same
                    // data (no-op from the user's perspective).
                    //
                    // IMPORTANT: dispatch happens AFTER setCurrentUser so current_user is non-null when the action
                    // runs the spread merge. If we dispatched before, the merge would spread {} (empty) and wipe
                    // the user fields we just committed.
                    if (context.state.current_user) {
                        await context.dispatch('loadCurrentUserWallets')
                    }

                    // Track login
                    const user = await Storage.getCurrentUser();
                    if (user && user.id && window.usageTracker) {
                        window.usageTracker.track('petty-cash', {
                            userId: user.id.toString(),
                            feature: 'auth',
                            action: 'login'
                        });
                    }

                    return user;
                }).catch(err => errorHandler.tomcatError(err))
        },
        // GINGER-20260711-USERID-MERCHANT-DASHBOARD-FIX:
        // Re-added from v1.4.2 hotfix (EDWARD-20260608) which was inadvertently dropped during the
        // v1.4.19 USERID-CONSOLIDATION-FIX cleanup. Dispatched from validateUser2 after OTP commit
        // when current_user is non-null.
        //
        // GINGER-20260711-v1.4.29 (replaces v1.4.28 attempt + rollback): switched back to
        // /getWallet/{id} — the proper per-user endpoint that JOINs the user_wallet bridge table.
        // The v1.4.28 attempt failed because the hydration race in NavigationDrawer.vue's local
        // `user` data masked the role display as "Unknown" coincidentally with the swap.
        // Now: v1.4.29 keeps this swap AND fixes the hydration race separately (see NavigationDrawer).
        // The /get-all-wallets directory endpoint would have returned ALL wallets, silently bypassing
        // the navbar gate `v-if="currentUser.wallets.length"` for every user — the original bug.
        loadCurrentUserWallets: async (context) => {
            // Defensive guard: if current_user has no id yet (race during login), bail silently.
            // Mirrors NavigationDrawer.vue:207 checkIsManger guard — same `curUser.id == null` pattern.
            const userId = context.state.current_user && context.state.current_user.id
            if (userId == null) {
                // GINGER-20260711-v1.4.29: explicit early-return so a missing user id never sends
                // ?userid=undefined to the BE. Non-fatal; the navbar gate just stays closed.
                return
            }
            return axios.get(ticketApi2 + 'getWallet/' + userId)
                .then(({ data }) => {
                    // Merge wallets into current_user without losing other fields (role, username, etc.
                    // preserved through the spread). Wallet shape from this endpoint is
                    // `{api_key, wallet_name, primary}` — no `id` field. That's correct because the
                    // navbar gate only needs `.length`, not any per-wallet field. Components that need
                    // `wallet.id` (Dashboard/DeptManager dropdowns) call /get-all-wallets directly.
                    const merged = {
                        ...(context.state.current_user || {}),
                        wallets: data
                    }
                    return context.commit('setCurrentUser', merged)
                })
                .catch(err => {
                    // Silent skip on failure — never break the login flow over a wallet fetch failure.
                    // The hardcoded '1' fallback in UserLoginForm.vue + checkIsManger guard in NavigationDrawer
                    // cover the worst case where this silently fails and wallets stays empty.
                    console.warn('[loadCurrentUserWallets] fetch failed (non-fatal):', err && err.message)
                })
        },
        getwallets: async (context, queryString) => {
            return axios.get(`${ticketApi2}getRequests?${queryString}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err));
        },
        searchUsers: (context, username) => {
            return axios.post(ticketApi + 'user/search', {
                Username : username
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        // GINGER-20260710-FILE4-LIVE: hydrate Vuex state from Capacitor Storage on app startup.
        // Called from App.vue:created(). Returns { sessionId, user } so the caller can branch
        // (e.g. show login redirect if both are null). If Storage throws (corrupt JSON, missing
        // key) we swallow + log so a broken persistence layer never blocks app boot.
        restoreSession: async (context) => {
            try {
                const sessionId = await Storage.getSessionID()
                const user = await Storage.getCurrentUser()
                if (sessionId) await context.commit('setSessionID', sessionId)
                if (user) await context.commit('setCurrentUser', user)
                return { sessionId: sessionId || null, user: user || null }
            } catch (err) {
                console.warn('[restoreSession] storage read failed:', err && err.message)
                return { sessionId: null, user: null }
            }
        },
    }
}
